export const getPlural = (translatedText: string, plural = false) =>
  !plural ? translatedText : `${translatedText}s`;
